import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcTelegramAnalyticsIcon = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 40 40",
  iconname: "IconIcTelegramAnalyticsIcon"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip0_6001_823)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip1_6001_823)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.8 0H4.2C1.8804 0 0 1.8804 0 4.2V23.8C0 26.1196 1.8804 28 4.2 28H23.8C26.1196 28 28 26.1196 28 23.8V4.2C28 1.8804 26.1196 0 23.8 0Z",
  fill: "#29B6F6"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip2_6001_823)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.3801 -1C8.83145 -1 5.42818 0.409681 2.91893 2.91893C0.409681 5.42818 -1 8.83145 -1 12.3801C-1 15.9287 0.409681 19.3319 2.91893 21.8412C5.42818 24.3504 8.83145 25.7601 12.3801 25.7601C15.9287 25.7601 19.3319 24.3504 21.8412 21.8412C24.3504 19.3319 25.7601 15.9287 25.7601 12.3801C25.7601 8.83145 24.3504 5.42818 21.8412 2.91893C19.3319 0.409681 15.9287 -1 12.3801 -1Z",
  fill: "#29B6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8589 8.15155L18.201 20.3376C18.201 20.3376 18.0867 20.8945 17.3176 20.8945C16.9089 20.8945 16.6981 20.7199 16.6981 20.7199L10.9409 16.43L8.12395 15.1551L4.50879 14.2917C4.50879 14.2917 3.86523 14.1248 3.86523 13.6469C3.86523 13.2487 4.52724 13.0588 4.52724 13.0588L19.652 7.6635C19.652 7.6635 20.1139 7.51377 20.4509 7.51441C20.6581 7.51441 20.8944 7.59405 20.8944 7.83298C20.8944 7.99227 20.8589 8.15155 20.8589 8.15155Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.38 17.3573L10.2927 20.7726C10.2927 20.7726 10.2019 20.8891 10.0807 20.8941C10.0387 20.8961 9.99357 20.885 9.94727 20.8506L10.5346 14.8125L12.38 17.3573Z",
  fill: "#B0BEC5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9752 10.0814C15.8871 9.93048 15.7245 9.90304 15.6098 10.0176L8.73047 15.4354C8.73047 15.4354 9.82837 19.4776 9.99571 20.1774C10.1636 20.8779 10.2981 20.8943 10.2981 20.8943L10.8006 16.802L15.9262 10.5617C16.0409 10.4471 16.0623 10.2323 15.9752 10.0814Z",
  fill: "#CFD8DC"
}))), /*#__PURE__*/React.createElement("rect", {
  x: "20.5208",
  y: "20.7883",
  width: "16.5764",
  height: "16.5764",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 37.7778V22.2222C40 21.6329 39.7659 21.0676 39.3491 20.6509C38.9324 20.2341 38.3671 20 37.7778 20H22.2222C21.6329 20 21.0676 20.2341 20.6509 20.6509C20.2341 21.0676 20 21.6329 20 22.2222V37.7778C20 38.3671 20.2341 38.9324 20.6509 39.3491C21.0676 39.7659 21.6329 40 22.2222 40H37.7778C38.3671 40 38.9324 39.7659 39.3491 39.3491C39.7659 38.9324 40 38.3671 40 37.7778ZM26.6667 36.6667H24.4444V30H26.6667V36.6667ZM31.1111 36.6667H28.8889V24.4444H31.1111V36.6667ZM35.5556 36.6667H33.3333V27.7778H35.5556V36.6667Z",
  fill: "#7B61FF"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip0_6001_823"
}, /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip1_6001_823"
}, /*#__PURE__*/React.createElement("rect", {
  width: "28",
  height: "28",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip2_6001_823"
}, /*#__PURE__*/React.createElement("rect", {
  width: "44.8",
  height: "44.8",
  fill: "white"
}))));
export { IconIcTelegramAnalyticsIcon as default };
//# sourceMappingURL=IconIcTelegramAnalyticsIcon.js.map